import type { EventSourceMessage } from '@microsoft/fetch-event-source';

import { logger } from '@luna/logger';

import { streamSseEvents } from './SSEEventsNetworkService';

export type SSEEventBus = EventTarget;
export type ReadonlySSEEventBus = Omit<SSEEventBus, 'dispatchEvent'>;

interface SSEEvent<T> {
    eventType: string;
    payloads: T;
}

export const SSE_EVENTS_NAMESPACE = 'sse';
const KEEP_ALIVE_EVENT = 'keep-alive';

function handleEvent({
    eventBus,
    event,
}: {
    eventBus: SSEEventBus;
    event: EventSourceMessage;
}): void {
    try {
        const data: SSEEvent<unknown> = JSON.parse(event.data);

        eventBus.dispatchEvent(
            new CustomEvent(`${SSE_EVENTS_NAMESPACE}:${data.eventType}`, { detail: data.payloads }),
        );
    } catch {
        logger.error('Could not parse sse event', event);
    }
}

export async function dispatchSseEvents({
    eventBus,
    signal,
}: {
    eventBus: SSEEventBus;
    signal: AbortSignal;
}): Promise<void> {
    return streamSseEvents({
        signal,
        onEvent: (event) => {
            if (event.event !== KEEP_ALIVE_EVENT) {
                handleEvent({ eventBus, event });
            }
        },
    });
}
